export const roomsJson = [
  {
    "id": 1,
    "name": "Deluxe A-123",
    "bed_type": "Double Bed",
    "photo": 'https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80',
    "amenities": ["Wifi", "Towels", "LED TV"],
    "rate": 245,
    "status": "Available"
  },
  {
    "id": 2,
    "name": "Deluxe B-234",
    "bed_type": "Single Bed",
    "photo": 'https://images.unsplash.com/photo-1618221118493-9cfa1a1c00da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
    "amenities": ["Wifi", "Towels", "Shower"],
    "rate": 168,
    "status": "Booked"
  },
  {
    "id": 3,
    "name": "Deluxe C-345",
    "bed_type": "Double Bed",
    "photo": 'https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80',
    "amenities": ["Wifi", "Towels", "LED TV", "Shower"],
    "rate": 305,
    "status": "Available"
  },
  {
    "id": 4,
    "name": "Deluxe D-456",
    "bed_type": "Suite",
    "photo": 'https://images.unsplash.com/photo-1566665797739-1674de7a421a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80',
    "amenities": ["Wifi", "Towels", "Shower"],
    "rate": 114,
    "status": "Available"
  },
  {
    "id": 5,
    "name": "Deluxe E-567",
    "bed_type": "Double Superior",
    "photo": 'https://images.unsplash.com/photo-1584132915807-fd1f5fbc078f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2000&q=80',
    "amenities": ["Wifi", "Towels", "LED TV"],
    "rate": 563,
    "status": "Booked"
  },
  {
    "id": 6,
    "name": "Deluxe F-678",
    "bed_type": "Single Bed",
    "photo": 'https://images.unsplash.com/photo-1618221118493-9cfa1a1c00da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
    "amenities": ["Wifi", "Towels", "Shower"],
    "rate": 214,
    "status": "Available"
  },
  {
    "id": 7,
    "name": "Deluxe G-789",
    "bed_type": "Double Bed",
    "photo": 'https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80',
    "amenities": ["Wifi", "Towels", "LED TV", "Shower"],
    "rate": 503,
    "status": "Available"
  },
  {
    "id": 8,
    "name": "Deluxe H-890",
    "bed_type": "Single Bed",
    "photo": 'https://images.unsplash.com/photo-1618221118493-9cfa1a1c00da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
    "amenities": ["Wifi", "Towels", "Shower"],
    "rate": 77,
    "status": "Booked"
  },
  {
    "id": 9,
    "name": "Deluxe I-901",
    "bed_type": "Double Bed",
    "photo": 'https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80',
    "amenities": ["Wifi", "Towels", "LED TV"],
    "rate": 325,
    "status": "Available"
  },
  {
    "id": 10,
    "name": "Deluxe J-012",
    "bed_type": "Single Bed",
    "photo": 'https://images.unsplash.com/photo-1618221118493-9cfa1a1c00da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
    "amenities": ["Wifi", "Towels", "LED TV", "Shower"],
    "rate": 432,
    "status": "Available"
  },
  {
    "id": 11,
    "name": "Deluxe K-123",
    "bed_type": "Double Bed",
    "photo": 'https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80',
    "amenities": ["Wifi", "Towels", "LED TV"],
    "rate": 457,
    "status": "Booked"
  },
  {
    "id": 12,
    "name": "Deluxe L-234",
    "bed_type": "Single Bed",
    "photo": 'https://images.unsplash.com/photo-1618221118493-9cfa1a1c00da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
    "amenities": ["Wifi", "Towels", "Shower"],
    "rate": 177,
    "status": "Available"
  },
  {
    "id": 13,
    "name": "Deluxe M-345",
    "bed_type": "Double Bed",
    "photo": 'https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80',
    "amenities": ["Wifi", "Towels", "LED TV", "Shower"],
    "rate": 589,
    "status": "Available"
  },
  {
    "id": 14,
    "name": "Deluxe N-456",
    "bed_type": "Single Bed",
    "photo": 'https://images.unsplash.com/photo-1618221118493-9cfa1a1c00da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
    "amenities": ["Wifi", "Towels", "LED TV"],
    "rate": 102,
    "status": "Booked"
  },
  {
    "id": 15,
    "name": "Deluxe O-567",
    "bed_type": "Double Bed",
    "photo": 'https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80',
    "amenities": ["Wifi", "Towels", "Shower"],
    "rate": 372,
    "status": "Available"
  },
  {
    "id": 16,
    "name": "Deluxe P-678",
    "bed_type": "Single Bed",
    "photo": 'https://images.unsplash.com/photo-1618221118493-9cfa1a1c00da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
    "amenities": ["Wifi", "Towels", "LED TV", "Shower"],
    "rate": 217,
    "status": "Booked"
  },
  {
    "id": 17,
    "name": "Deluxe Q-789",
    "bed_type": "Double Bed",
    "photo": 'https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80',
    "amenities": ["Wifi", "Towels", "LED TV"],
    "rate": 321,
    "status": "Available"
  },
  {
    "id": 18,
    "name": "Deluxe R-890",
    "bed_type": "Single Bed",
    "photo": 'https://images.unsplash.com/photo-1618221118493-9cfa1a1c00da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
    "amenities": ["Wifi", "Towels", "Shower"],
    "rate": 78,
    "status": "Available"
  },
  {
    "id": 19,
    "name": "Deluxe S-901",
    "bed_type": "Double Bed",
    "photo": 'https://images.unsplash.com/flagged/photo-1556438758-8d49568ce18e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80',
    "amenities": ["Wifi", "Towels", "LED TV", "Shower"],
    "rate": 555,
    "status": "Booked"
  },
  {
    "id": 20,
    "name": "Deluxe T-012",
    "bed_type": "Single Bed",
    "photo": 'https://images.unsplash.com/photo-1618221118493-9cfa1a1c00da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
    "amenities": ["Wifi", "Towels", "LED TV"],
    "rate": 198,
    "status": "Available"
  }
]